import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class QaLocatorService {
	/**
	 * Renders QA locator everytime user change view
	 * @param view: date picker current view
	 * @param datePickerName: date picker name/used
	 * @param renderer: renderer from component
	 */
	datePickerViewChange(view: string, datePickerName: string, renderer: any): void {
		const datePickerCalendarContent = document.querySelector("mat-datepicker-content");

		if (view === "month") {
			const monthPickerCell = datePickerCalendarContent?.querySelectorAll(
				"mat-calendar mat-month-view .mat-calendar-body-cell-content"
			);

			renderer.setAttribute(datePickerCalendarContent, "date-test", `${datePickerName}-calendar-picker`);
			monthPickerCell?.forEach(cell => {
				if (cell.classList.contains("mat-calendar-body-selected")) {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-selected-date`);
				} else if (cell.classList.contains("mat-calendar-body-today")) {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-current-date`);
				} else {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-date`);
				}
			});
		} else if (view === "year") {
			const yearPickerCell = datePickerCalendarContent?.querySelectorAll(
				"mat-calendar mat-year-view .mat-calendar-body-cell-content"
			);

			renderer.setAttribute(datePickerCalendarContent, "date-test", `${datePickerName}-calendar-picker`);
			yearPickerCell?.forEach(cell => {
				if (cell.classList.contains("mat-calendar-body-selected")) {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-selected-month`);
				} else if (cell.classList.contains("mat-calendar-body-today")) {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-current-month`);
				} else {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-month`);
				}
			});
		} else if (view === "multi-year") {
			const multiYearPickerCell = datePickerCalendarContent?.querySelectorAll(
				"mat-calendar mat-multi-year-view .mat-calendar-body-cell-content"
			);

			renderer.setAttribute(datePickerCalendarContent, "date-test", `${datePickerName}-calendar-picker`);
			multiYearPickerCell?.forEach(cell => {
				if (cell.classList.contains("mat-calendar-body-selected")) {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-selected-year`);
				} else if (cell.classList.contains("mat-calendar-body-today")) {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-current-year`);
				} else {
					renderer.setAttribute(cell, "data-test", `${datePickerName}-year`);
				}
			});
		}
	}
}
